import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Modal, { MODAL_STATE } from '@parchment/modal';
import { Banner, Button } from '@parchment/atoms';
import { CheckIcon, IndianaAchievementWalletIcon } from '@parchment/icons';
import useEventTracking from '../hooks/useEventTracking';

const noop = () => {};

export default function AchievementShareModal({
    open = false,
    institutionId = 0,
    learnerId = 0,
    institutionName = '',
    credentialAwardId = 0,
    credentialName = '',
    emailAddress = '',
    onClose = noop
}) {
    const [modalState, setModalState] = useState(MODAL_STATE.DEFAULT);
    const [banner, setBanner] = useState(<></>);
    const { shared, handleEventTracking, resetSharedState } =
        useEventTracking({
            learnerId,
            credentialAwardId,
            institutionId,
            institutionName
        });

    useEffect(() => {
        if (shared === false) {
            setBanner(<Banner message='There was an error sharing your credential. Please try again'
                              context='error' />);
        }
    }, [shared]);

    const handleClose = () => {
        onClose();
        resetSharedState();
    };

    const handleOnClick = async () => {
        setModalState(MODAL_STATE.PROCESSING_WITH_SPINNER);

        await handleEventTracking();
        setModalState(MODAL_STATE.DEFAULT);
    };

    const modalTitle = (
        <>
            Indiana Achievement Wallet
        </>
    );

    const modalIcon = (
        <ModalIconWrapper>
            { shared ? <CheckIcon /> : <IndianaAchievementWalletIcon /> }
        </ModalIconWrapper>
    );

    let modalText = (
        <ModalTextWrapper>
            {modalIcon}
            <div>
                The Indiana Achievement Wallet is available to <b>{institutionName}</b> learners so that
                they may see their validated skills from digital credentials. The Indiana Achievement Wallet
                is another context to share your achievements.
            </div>
            <div>
                Click below to share your <b>{credentialName}</b> with the Indiana Achievement Wallet. You'll receive an
                email from Parchment at <b>{emailAddress}</b> when it has been made available
                to the Indiana Achievement Wallet.
            </div>
        </ModalTextWrapper>
    );

    let footer = (
        <>
            <Button name='modal-cancel-button'
                    onClick={handleClose}
                    ghost>
                Cancel
            </Button>
            <Button name='modal-share-credential-button'
                    onClick={handleOnClick}>
                Share This Credential
            </Button>
        </>
    );

    if (shared) {
        modalText = (
            <ModalTextWrapper>
                {modalIcon}
                <div>
                    Your request to share your <b>{credentialName}</b> with the Indiana Achievement Wallet was successful.
                    You'll receive an email from Parchment at <b>{emailAddress}</b> when it has
                    been made available to the Indiana Achievement Wallet.
                </div>
            </ModalTextWrapper>
        );

        footer = (
            <>
                <Button name='modal-confirm-button'
                        onClick={handleClose}
                        ghost>
                    OK
                </Button>
            </>
        );
    }

    return (
        <Modal closeable
               open={open}
               onClose={handleClose}
               title={modalTitle}
               footer={footer}
               modalState={modalState}
               loadingMessage='Sharing Credential'
               loadingContent={<div>Please wait...</div>}
               banner={banner} >
            {modalText}
        </Modal>
    );
}

const ModalTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    text-align: initial;
`;

const ModalIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 7em;
    margin: 20px 0;
`;
